import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from './shared/AuthGuard/auth.guard';
import { ContractorLoginComponent } from './shared/components/contractor-login/contractor-login.component';
import { FileViewerComponent } from './shared/components/file-viewer/file-viewer.component';
import { HomeComponent } from './shared/components/home/home.component';
import { LoginComponent } from './shared/components/login/login.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { PobaddMembersComponent } from './shared/components/pobadd-members/pobadd-members.component';
import { FaqComponent } from './shared/components/faq/faq.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contractorlogin',
    component: ContractorLoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'changepassword',
    component: ContractorLoginComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pob-add-members/:passId',
    component: PobaddMembersComponent,
  },
  {
    path: 'observation',
    loadChildren: () => import(`./observation/observation.module`).then(
      module => module.ObservationModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'actiontracker',
    loadChildren: () => import(`./actiontracker/actiontracker.module`).then(
      module => module.ActiontrackerModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'masterscreen',
    loadChildren: () => import(`./masterscreen/masterscreen.module`).then(
      module => module.MasterscreenModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'risk',
    loadChildren: () => import(`./risk/risk.module`).then(
      module => module.RiskModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'incident',
    loadChildren: () => import(`./incident/incident.module`).then(
      module => module.IncidentModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'task',
    loadChildren: () => import(`./task/task.module`).then(
      module => module.TaskModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'inspection',
    loadChildren: () => import(`./inspection/inspection.module`).then(
      module => module.InspectionModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'pob',
    loadChildren: () => import(`./person-on-board/person-on-board.module`).then(
      module => module.PersonOnBoardModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'ptw',
    loadChildren: () => import(`./permit-to-work/permit-to-work.module`).then(
      module => module.PermitToWorkModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'tnc',
    loadChildren: () => import(`./training-and-competency/training-and-competency.module`).then(
      module => module.TrainingAndCompetencyModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'dl',
    loadChildren: () => import(`./document-library/document-library.module`).then(
      module => module.DocumentLibraryModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'pd',
    loadChildren: () => import(`./performance-dashboard/performance.module`).then(
      module => module.PerformanceModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'file-viewer/:descriptionListId',
    component: FileViewerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'faq',
    component: FaqComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule, TranslateModule]
})
export class AppRoutingModule { }
